import { render, staticRenderFns } from "./orderedit_form.vue?vue&type=template&id=525c4fb2&scoped=true&"
import script from "./orderedit_form.vue?vue&type=script&lang=js&"
export * from "./orderedit_form.vue?vue&type=script&lang=js&"
import style0 from "./orderedit_form.vue?vue&type=style&index=0&id=525c4fb2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c4fb2",
  null
  
)

export default component.exports